import { Box, Card, CardContent, Grid2 } from '@mui/material'
import React from 'react'

import TabHeader from '@/app/component/atom/tab-header'
import { useGetBalance } from '@/app/module/payments/hooks/use-get-balance'

import AutoRecharge from './recharge/auto-recharge'
import SpendNotifications from './spend/spend-notifications'

const Settings: React.FC = () => {
  const { data: balance } = useGetBalance()

  return (
    <Box pb={2}>
      <Grid2 container spacing={2}>
        <Grid2 size={{ md: 8, xs: 12 }}>
          <Card>
            <TabHeader title="Auto Recharge" />
            <CardContent>{balance && <AutoRecharge autoRecharge={balance} onClose={() => {}} />}</CardContent>
          </Card>
        </Grid2>
        <Grid2 size={{ md: 8, xs: 12 }}>
          <Card>
            <TabHeader title="Notifications and Spend Limits" />
            <CardContent>
              <SpendNotifications />
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>
    </Box>
  )
}

export default Settings
